import { SchoolSubject } from './SchoolSubject';

export const MANUAL_BOOKS = {
  teacher: 'ca8733de-3736-4a57-87d6-07db8e826c27',
  author: '84fa3a64-a912-40e3-b924-631c2c826f86',
  student: 'f2bc7fdd-42bd-429e-b5e7-017477039422',
};

export interface IUserBook {
  id: string;
  title: string;
  chapterDepth: number;
  groups: IUserBookGroup[];
}

export interface IUserBookGroup {
  id: string;
  name: string;
}

export interface IStudentBookBag extends IBook {
  lastViewedTrajectory?: IStudentBookBagLastViewdTrajectory;
  bookmark?: IStudentBookBagBookmark[];
}

export interface IBook {
  id: string;
  title: string;
  isDefault: boolean;
  coverImage: string;
  chapterDepth: number;
}

export interface IStudentBookBagLastViewdTrajectory {
  trajectoryId: string;
  chapterId: string;
  trajectoryTitle: string;
}

export interface IStudentBookBagBookmark {
  bookId: string;
  chapterId: string;
  trajectoryId: string;
  bookmarkId: string;
  blockId: string;
  section: string;
  pageId: string;
  title: string;
  fromMyTeacher: boolean;
}

export type Book = {
  id: string;
  title: string;
  description: string;
  coverImage: string;
  chapterDepth: number;
  createdAt: string;
  updatedAt: string;
  schoolSubjects?: SchoolSubject[];
  isDefault: boolean;
  isPreview: boolean;
  knowledgeBaseUrl: string;
  hasCalculatorGraphical: boolean;
  hasCalculatorScientific: boolean;
  hasAlgebraicCalculator: boolean;
  pdfUrl?: string;
};

export enum SectionBookType {
  OWNED = 'owned_book',
  AVAILABLE = 'available_book',
  PREVIEW = 'preview_book',
  TRAINING = 'training_book',
  GENERIC = 'generic_book',
}

// BACKEND

export type TeacherBook = {
  id?: string;
  title: string;
  description: string;
  coverImage: string;
  numberOfGrades: number;
};

export type TeacherBookSection = {
  isOpen: boolean;
  isEnabled: boolean;
  books: TeacherBook[];
  totalOfPages?: number;
};
